import { Layout } from "antd";
import { AppRoutes } from "./app/routes";
import { useHostHeightReporter } from "./host/useHostHeightReporter";
import { useSentryUser } from "./host/useSentryUser";

const { Content } = Layout;

export function App() {
  useHostHeightReporter();
  useSentryUser();

  return (
    // No `minHeight: 100vh` here on purpose: when embedded, the host
    // sizes the iframe via onHeightChange, and using viewport units in
    // the child would feed scrollHeight back to the parent and prevent
    // it from ever shrinking to fit smaller content.
    //
    // Backgrounds are transparent so the host page shows through —
    // AntD's Layout/Content paint `colorBgLayout` by default.
    <Layout style={{ background: "transparent" }}>
      <Content style={{ position: "relative", background: "transparent" }}>
        <AppRoutes />
      </Content>
    </Layout>
  );
}
